import { safeDefine } from "../../registration/safe-define.js";
import { SliderElement } from "../../ui/slider/element.js";
//#region src/define/ui/slider.ts
safeDefine(SliderElement);
//#endregion

//# sourceMappingURL=slider.js.map